<template>
  <div class="w-full top-field">
    <div class="required" v-if="'required' in property && property.required === true">Required</div>

    <NamingConventionSeverityOverridesField
      v-model="fieldValue"
      :property="property"
      v-if="componentType === 'NamingConventionSeverityOverrides'"
    />

    <n-input-number
    v-model:value="fieldValue"
    clearable
    :required="property.required"
    v-if="componentType == 'Number'"
    />
    <n-switch
    v-model:value="fieldValue"
    v-if="componentType == 'Boolean'"
    />
    <n-input
    class="w-full"
    v-model:value="fieldValue"
    v-if="componentType == 'String'"
    />
    <EnumField
    class="w-100"
    v-if="componentType == 'Enum'"
    v-model="fieldValue"
    :property="property"
    ></EnumField>
    <ObjectField
    v-if="componentType == 'Object'"
    v-model="fieldValue"
    :property="property"
    ></ObjectField>
    <ArrayField
    v-if="componentType == 'ObjectArray'"
    v-model="fieldValue"
    :property="property"
    ></ArrayField>
    <ArrayField
    v-if="componentType == 'Array'"
    v-model="fieldValue"
    :property="property"
    ></ArrayField>
    <EnumArrayField
    class="w-100"
    v-if="componentType == 'EnumArray'"
    v-model="fieldValue"
    :property="property"
    ></EnumArrayField>
    <div class="description" v-if="property.description">{{ property.description }}</div>
  </div>
</template>

<script>
import { NInput, NInputNumber, NSwitch } from 'naive-ui'
import ArrayField from '@/components/ManageAccount/Rules/fields/ArrayField'
import EnumField from '@/components/ManageAccount/Rules/fields/EnumField'
import EnumArrayField from '@/components/ManageAccount/Rules/fields/EnumArrayField'
import ObjectField from '@/components/ManageAccount/Rules/fields/ObjectField'
import NamingConventionSeverityOverridesField from './fields/NamingConventionSeverityOverridesField.vue'

export default {
  components: {
    NInput,
    NInputNumber,
    NSwitch,
    ArrayField,
    EnumField,
    EnumArrayField,
    ObjectField,
    NamingConventionSeverityOverridesField
  },
  props: [
    'modelValue',
    'propertyKey',
    'property'
  ],
  watch: {
    fieldValue: {
      handler(newVal) {
        this.$emit('update:modelValue', newVal);
      },
      deep: true
    }
  },
  data() {
    return {
      fieldValue: null
    };
  },
  computed: {
    componentType() {
      if (!this.property) return '';
      if (this.property.widget) return this.property.widget;
      if (this.property.type === 'number') return 'Number';
      if (this.property.type === 'boolean') return 'Boolean';
      if (this.property.type == 'string' && this.property.disposition !== 'jobstorage_filename' && !this.property.enum) return 'String';
      if (this.property.type === 'string' && this.property.enum) return 'Enum';
      if (this.property.type === 'object') return 'Object';
      if (this.property.type === 'array' && Object.prototype.hasOwnProperty.call(this.property.elements, 'properties')) return 'ObjectArray';
      if (this.property.type === 'array' && !Object.prototype.hasOwnProperty.call(this.property.elements, 'enum')) return 'Array';
      if (this.property.type == 'array' && 'enum' in this.property.elements) return 'EnumArray';
      return '';
    }
  },
  created() {
    this.fieldValue = this.modelValue;
  }
}
</script>

<style lang="scss">
.top-field {

  > .required {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-style: italic;
  color: var(--n-tab-text-color-active);
  }

}
</style>